import { useEffect } from 'react';
import * as Sentry from '@sentry/react';

import type { Me } from '@/entities/me';

export function useSentrySyncMe(me: Me | undefined) {
  useEffect(
    function () {
      if (me) {
        Sentry.setUser({
          id: me.id,
          email: me.email,
          username: me.firstName,
        });
        Sentry.setTag('tenant', me.tenant);
        Sentry.setTag('customer', me.tenant);
      }

      return function () {
        Sentry.setUser(null);
        Sentry.setTag('tenant', undefined);
        Sentry.setTag('customer', undefined);
      };
    },
    [me],
  );
}
